import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import CS from '../../constants/Styles';
import { BackgroundGradient, SafeAreaView } from '../../components';
import DisputeCarouselItem from '../../components/Carousel/Dispute';
import { FontAwesome5 } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import disputeItems from './HowItWorksData';

const HowItWorksScreen = ({ navigation, route }) => {
  const linkTo = useLinkTo();

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/disputes');
    }
  }

  return (
    <SafeAreaView style={[CS.safe, styles.outerContainer]}>
      <BackgroundGradient />
      <ScrollView style={styles.container}>
        <View style={styles.titleContainer}>
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, CS.noMargin]}>How Disputes Work</Text>
          <TouchableOpacity onPress={goBack} style={styles.backArrow}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </TouchableOpacity>
        </View>
        {disputeItems.map((item, i) => {
          return <DisputeCarouselItem item={item} agreementId={route.params?.agreementId || null} key={i} />
        })}
      </ScrollView>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  outerContainer: {
    paddingHorizontal: 10,
    // justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    maxWidth: 768,
    // backgroundColor: 'pink',
    marginBottom: 10,
  },
  titleContainer: {
    marginVertical: 20,
    alignItems: 'center',
    // backgroundColor: 'red',
  },
  backArrow: {
    position: 'absolute',
    top: 5,
    left: 0,
  },
});

export default HowItWorksScreen;